export const T = {
  siteTitle: {
    hu: 'Nettó bér kalkulátor',
    en: 'Net Salary Calculator'
  },
  haviBruttoBer: {
    hu: 'Havi bruttó bér',
    en: 'Monthly Gross Salary'
  },
  minimalber: {
    hu: 'Minimálbér',
    en: 'Minimum Wage'
  },
  berminimum: {
    hu: 'Bérminimum',
    en: 'Skilled Minimum'
  },
  atlagber: {
    hu: 'Átlagbér',
    en: 'Average Salary'
  },
  nettoBer: {
    hu: 'Nettó bér',
    en: 'Net Salary'
  },
  frissHazasokKedvezmenye: {
    hu: 'Első házasok kedvezménye',
    en: 'Newlywed Tax Benefit'
  },
  szjaMentesseg: {
    hu: '25 év alattiak szja-mentessége',
    en: 'Tax Exemption Under 25'
  },
  szjaMentesAnya: {
    hu: 'SZJA-mentes anya',
    en: 'Tax-exempt mother'
  },
  fiatalAnya: {
    hu: '30 év alatti anya',
    en: 'Mother under 30'
  },
  szemelyiKedvezmeny: {
    hu: 'Személyi kedvezmény',
    en: 'Personal Allowance'
  },
  kedvezmenyezettEltartott: {
    hu: 'Kedvezményezett eltartott',
    en: 'Dependent Children'
  },
  nemKedvezmenyezettEltartott: {
    hu: 'Nem kedvezményezett eltartott',
    en: 'Other Dependents'
  },
  betegszabadsag: {
    hu: 'Betegszabadság',
    en: 'Sick Leave'
  },
  betegszabadsagInfo: {
    hu: 'Minden évben 15 munkanap betegszabadság jár. Ha ez elfogyott, akkor táppénzre kell menned (ezt még nem kezeli a kalkulátor). A betegszabadságot a munkaadód fizeti és összege a béred 70%-a.',
    en: 'You are entitled to 15 workdays of sick leave per year. If used up, you need to go on sick pay (not handled by calculator yet). Sick leave is paid by your employer at 70% of your salary.'
  },
  honap: {
    hu: 'Hónap',
    en: 'Month'
  },
  months: {
    hu: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'],
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },
  adatvedelem: {
    hu: 'Adatvédelem',
    en: 'Privacy'
  },
  bruttoNettoInfo: {
    hu: 'Mi az a bruttó/nettó bér?',
    en: 'What is gross/net salary?'
  },
  privacyInfo: {
    hu: 'A kalkulátor minden számítást a böngészőben végez el.\nAz adatok nem hagyják el a gépedet. Analitikai adatokat viszont gyűjt (böngésző típusa, képernyőméret, ország, nyelv). Ezek a honlap továbbfejlesztését szolgálják.',
    en: 'All calculations are performed in your browser.\nData never leaves your computer. However, analytics data is collected (browser type, screen size, country, language) to help improve the site.'
  },
  nettoBerInfo: {
    hu: 'Az az összeg, amit átutalással vagy készpénzben megkapsz a fizetésed napján.',
    en: 'The amount you receive via bank transfer or cash on payday.'
  },
  bruttoBerInfo: {
    hu: 'Ez a jövedelmed. Amikor a béredről megállapodsz a munkáltatóddal, akkor általában erről az összegről alkudoztok. A fizetés kiutalásakor ebből levonják a különböző adókat (lásd. lenti táblázat első négy sorát) és ami ezután megmarad, az a nettó bér. Ha adókedvezményt veszel igénybe (például gyermeket nevelsz), akkor kevesebb adót vonnak le és nagyobb lesz a nettó béred.',
    en: 'This is your income. When negotiating with your employer, this is usually the amount you discuss. Various taxes are deducted from this amount (see first four rows in the table below) and what remains is your net salary. If you claim tax benefits (e.g., for raising children), less tax is deducted and your net salary will be higher.'
  },
  munkaltatoiAdok : {
    hu: 'Munkáltatói adók',
    en: 'Employer Taxes'
  },
  munkaltatoiAdokInfo: {
    hu: 'Ha megnézed a lenti táblázatot, akkor láthatod, hogy vannak olyan adók is, amelyeket nem a bruttó bérből vonnak le. Ezek a szociális hozzájárulási adó és a szakképzési hozzájárulás. Ezeket a munkáltatód fizeti meg, még a bruttó béreden felül. Ha ezeket hozzáadod a bruttó béredhez, akkor kijön teljes bérköltséged. Ennyibe kerülsz a munkáltatódnak (ha csak a bért nézzük).',
    en: 'If you look at the table below, you can see there are taxes not deducted from your gross salary. These are the social contribution tax and vocational training contribution. Your employer pays these on top of your gross salary. Adding these to your gross salary gives you the total employment cost. This is how much you cost your employer (considering only the salary).'
  },
  netto: {
    hu: 'Nettó',
    en: 'Net'
  },
  szja: {
    hu: 'Jövedelemadó',
    en: 'Income Tax'
  },
  egb: {
    hu: 'TB járulék',
    en: 'Social Security'
  },
  nyug: {
    hu: 'Nyugdíjjárulék',
    en: 'Pension Contribution'
  },
  munk: {
    hu: 'Munkaerőpiaci járulék',
    en: 'Labour Market Contribution'
  },
  szoho: {
    hu: 'Szociális hozzájárulási adó',
    en: 'Social Contribution Tax'
  },
  szak: {
    hu: 'Szakképzési hozzájárulás',
    en: 'Vocational Training Contribution'
  },
  tableHeaderMonthly: {
    hu: 'Havi',
    en: 'Monthly'
  },
  tableHeaderYearly: {
    hu: 'Éves',
    en: 'Yearly'
  },
  totalCost: {
    hu: 'Teljes bérköltség',
    en: 'Total Employment Cost'
  },
  szjaOnePercent: {
    hu: 'SZJA 1%',
    en: 'Income Tax 1%'
  },
  copyLink: {
    hu: 'Eredmény (link) másolása vágólapra',
    en: 'Copy result (link) to clipboard'
  },
  clipboardError: {
    hu: 'Nem férek hozzá a vágólaphoz :(',
    en: 'Cannot access clipboard :('
  },
  feedback: {
    hu: 'Visszajelzés',
    en: 'Feedback'
  },
  loanCalculator: {
    hu: 'Hitel kalkulátor',
    en: 'Loan Calculator'
  },
  workdayCalculator: {
    hu: 'Munkanap kalkulátor',
    en: 'Workday Calculator'
  },
  salaryRanges: {
    hu: 'Fizetési sávok',
    en: 'Salary Ranges'
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/js/translations.js
// module id = 1
// module chunks = 0